export default "__VITE_ASSET__DBXUPA2v__"